import { ButtonCtaGhost, ButtonCtaPrimary, Card, Header4, Paragraph, Subheader, useNotifications } from '@tbitop/ui';
import classNames from 'classnames';
import { isNull, isUndefined } from 'lodash-es';
import { useId, useState } from 'react';
import { useAufgabeFuerKampagneErstellenMutation } from '../../../infrastructure/graphql/AufgabeFuerKampagneErstellenMutation';
import { useAufgabeLoeschenMutation } from '../../../infrastructure/graphql/AufgabeLoeschenMutation';
import type { Objekt, ObjektAdresse } from './objekt-list-types';


export type ObjektListItemProps = {
  objekt: Objekt;
  aufgabenId: string;
  onDirektAbschliessen: (aufgabenId: string, onDirektAbschliessen: () => void) => void;
};

export const ObjektListItemAktionAnlegen = ({ objekt, aufgabenId, onDirektAbschliessen }: ObjektListItemProps) => {
  const id = useId();
  const { success } = useNotifications();
  const { execute: executeAufgabeErstellen, loading: aufgabeErstellenInProgress } = useAufgabeFuerKampagneErstellenMutation();
  const { execute: executeAufgabeLoeschen, loading: aufgabeLoeschenInProgress } = useAufgabeLoeschenMutation();
  const [erstellenErfolgreich, setErstellenErfolgreich] = useState(false);
  const [_isProcessing, setIsProcessing] = useState(false);
  const [neueAufgabenId, setNeueAufgabenId] = useState<string>();

  const isProcessing = _isProcessing || aufgabeErstellenInProgress || aufgabeLoeschenInProgress;

  async function onDirektAbschliessenClick() {
    let aufgabenId: string | undefined | null = neueAufgabenId;
    if (!erstellenErfolgreich) {
      aufgabenId = await createAufgabe();
    }
    if (aufgabenId) {
      onDirektAbschliessen(aufgabenId, async () => {
        if (aufgabenId) {
          deleteAufgabe(aufgabenId);
        }
      });
    }
  }

  async function onErstellenClick() {
    if (!erstellenErfolgreich) {
      const aufgabenId = await createAufgabe();
      if (aufgabenId) {
        success(<div className="flex flex-col gap-3">
          <span>Erfolgreich erstellt</span>
        </div>);
      }
    }
  }

  async function createAufgabe() {
    setIsProcessing(true);
    const { data, errors } = await executeAufgabeErstellen({ aufgabenId: aufgabenId, objektId: objekt.id });

    if (!isUndefined(errors)) {
      return null;
    }

    setNeueAufgabenId(data?.aufgabeFuerKampagneErstellen.id);
    setIsProcessing(false);
    setErstellenErfolgreich(true);
    return data?.aufgabeFuerKampagneErstellen.id;
  }

  function onRueckgaengigClick() {
    if (!neueAufgabenId) {
      return;
    }
    deleteAufgabe(neueAufgabenId);
  }

  async function deleteAufgabe(aufgabeId: string) {
    setIsProcessing(true);
    const { errors } = await executeAufgabeLoeschen({ id: aufgabeId });

    if (!isUndefined(errors)) {
      return null;
    }

    setIsProcessing(false);
    setErstellenErfolgreich(false);
  }

  return (
    <Card role="listitem">
      <div className="mb-200 grid grid-cols-[1fr_0fr] grid-rows-1">
        <div className="text-tds-color-copy-on-light-10">
          <Header4 id={id}>{objekt.name}</Header4>
          <Subheader>{objekt.name2}</Subheader>
          <Subheader>{objekt.nummer}</Subheader>
        </div>
      </div>
      <ObjektAdresseParagraph adresse={objekt.adresse} />
      <div className="flex flex-col justify-end gap-3 [@media(min-width:420px)]:flex-row">
        <ButtonCtaPrimary onClick={!isProcessing ? onDirektAbschliessenClick : undefined} className={classNames('bg-success', 'border-success', erstellenErfolgreich ? 'hidden' : '')}>Direkt abschließen</ButtonCtaPrimary>
        {!erstellenErfolgreich ? <ButtonCtaPrimary onClick={!isProcessing ? onErstellenClick : undefined}>Erstellen</ButtonCtaPrimary> : <ButtonCtaGhost onClick={onRueckgaengigClick}>Rückgängig</ButtonCtaGhost>}
      </div>
    </Card>
  );
};

export type ObjektAdresseProps = {
  adresse: ObjektAdresse | null;
};

const ObjektAdresseParagraph = ({ adresse }: ObjektAdresseProps) => {
  if (isNull(adresse)) {
    return null;
  }
  return (
    <address className="not-italic text-tds-color-copy-on-light-50">
      <Paragraph>{adresse.strasse}, {adresse.postleitzahl} {adresse.ort}</Paragraph>
    </address>
  );
};

